/**
 * The product details which need to be passed in to show it inside the dialog.
 */

/**
 * Use baseUrl to generate advanced search URL for a specific workspace
 */

export const INITIAL_STATE = [];
export const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD':
      {
        const {
          payload: newProduct
        } = action;
        return addProduct(state, newProduct);
      }
    case 'UPDATE':
      {
        const {
          payload: updatePayload
        } = action;
        return updateProduct(state, updatePayload);
      }
    case 'SHOW':
      {
        const productIdToShow = action.payload.id;
        return showProduct(state, productIdToShow);
      }
    case 'REMOVE':
      {
        const productIdToRemove = action.payload.id;
        return removeProduct(state, productIdToRemove);
      }
    case 'HIDE_ALL':
      {
        return hideAllProducts(state);
      }
    default:
      {
        return state;
      }
  }
};
export function addProduct(products, addPayload) {
  // Check that new product id does not exist already
  if (products.filter(product => product.id === addPayload.id).length) {
    return products;
  }

  // Show error in console when duplicate order is added
  const duplicateOrder = products.find(({
    order
  }) => order === addPayload.order);
  if (duplicateOrder) {
    // eslint-disable-next-line no-console
    console.error(`product-search-dialog: Duplicate order of ${addPayload.order} has been set for the products of ${duplicateOrder.id} and ${addPayload.id}`);
  }

  // Add product to state and maintain sorted array using order
  const newProduct = {
    ...addPayload,
    isDisplayed: false
  };
  const unsorted = [...products, newProduct];
  const sorted = unsorted.sort((a, b) => a.order - b.order);
  return sorted;
}
export function updateProduct(products, updatePayload) {
  const productToUpdate = products.find(p => p.id === updatePayload.id);
  if (!productToUpdate) {
    throw new Error(`Cannot update ${updatePayload.id} before being added`);
  }
  const validUpdateKeys = ['generateAdvancedSearchUrl', 'tabRenderer'];
  const validUpdatePayload = Object.fromEntries(Object.entries(updatePayload).filter(([key]) => validUpdateKeys.includes(key)));
  Object.assign(productToUpdate, validUpdatePayload);
  return products;
}
export function showProduct(products, productIdToShow) {
  return products.map(product => ({
    ...product,
    isDisplayed: product.id === productIdToShow
  }));
}
export function removeProduct(products, productIdToRemove) {
  return products.filter(product => product.id !== productIdToRemove);
}
export function hideAllProducts(products) {
  return products.map(product => ({
    ...product,
    isDisplayed: false
  }));
}